<template>
  <div style="height: 100%;overflow: auto;">
    <grid ref="myGrid" @afterLoadData="loadFirstDetail" :class="data.analyseCode ? 'more-analyse-grid' : ''"
          :isAnalyseGrid="true" :gridConfigUrl="gridConfigUrl">
      <template slot="headerColumns">
        <li class="mTable-cell" v-if="data.analyseCode">
          <div class="mTable-cell-wrap">
            <span class="mTable-txt">显示详情</span>
          </div>
        </li>
        <li class="mTable-cell" v-if="data.detailBoardId">
          <div class="mTable-cell-wrap">
            <span class="mTable-txt">查看详情</span>
          </div>
        </li>
      </template>
      <template slot="bodyColumns" slot-scope="props">
        <li class="mTable-cell" v-if="data.analyseCode">
          <div class="mTable-cell-wrap">
          <span class="mTable-txt">
            <grid-menu-a
              @menu-click="showDetail(props.row)"
              name="显示详情"
            >
            </grid-menu-a>
          </span>
          </div>
        </li>
        <li class="main-table-cell" v-if="data.detailBoardId">
          <div class="main-table-cell-wrap">
          <span class="main-table-txt">
            <grid-menu-a
              @menu-click="toDetailBoard(props.row)"
              name="查看详情"
            >
            </grid-menu-a>
          </span>
          </div>
        </li>
      </template>
    </grid>
    <div class="more-analyse-box" v-if="data.analyseCode && params !== null && canShowAnalyse">
      <component class="more-analyse" :is="analyseView" :param="params"></component>
    </div>
  </div>
</template>

<script>
  import ShowAnalyse from '../show-analyse'
  import Grid from '../../../../../../components/grid/grid.vue'
  import GridMenuA from '../../../../../../components/grid-menu/grid-menu-a.vue'
  import util from '@/libs/util'
  import analyseUtil from '../analyse-util'

  export default {
    components: {
      ShowAnalyse,
      Grid,
      GridMenuA
    },
    props: {
      data: {
        type: 'Object'
      },
      search: {
        type: 'Object'
      }
    },
    name: 'grid-config',
    typeCode: '7',
    data() {
      return {
        analyseView: ShowAnalyse,
        gridConfigUrl: '/entity/analyse/analyseConfig/abstractGrid?gridId=' + this.data.gridId,
        params: {
          configCode: this.data.analyseCode
        },
        canShowAnalyse: false
      }
    },
    methods: {
      showDetail: function (row) {
        if (row) {
          this.params = null
          this.$nextTick(() => {
            this.params = {
              configCode: this.data.analyseCode,
              search: {
                ...this.search,
                id: row.id
              }
            }
            this.canShowAnalyse = true
          })
        }
      },
      loadFirstDetail: function () {
        this.showDetail(this.$refs.myGrid.page.items[0])
      },
      toDetailBoard: function (row) {
        analyseUtil.pushSearchStack({search: {parentId: row.id}}, this)
        let deep = this.$route.query && this.$route.query.deep ? parseInt(this.$route.query.deep) : 0
        util.changeRouter(this, {
          name: 'analyseBoard',
          query: {
            id: this.data.detailBoardId,
            deep: deep + 1,
            boardStackKey: analyseUtil.getBoardStackKey(this),
            parentId: row.id
          }
        })
      },
      getExtParams: function () {
        return {
          search: this.search
        }
      }
    }
  }
</script>

<style scoped>

  .more-analyse-grid {
    float: left;
    width: 65%;
  }

  .more-analyse-box {
    float: left;
    width: 34%;
    height: 100%;
    border-left: 1px solid #f5f5f5;
  }

  .more-analyse {
    height: 70% !important;
    margin-top: 10%;
  }

  .mTable-txt a {
    color: #677de0;
  }

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/grid-config.vue